'use client';
import { PFText } from './PFText';
import { Suspense, useEffect, useState } from 'react';
import { PFButton } from './PFButton';
import { usePush } from '@/common/usePush';
import { atomWithStorage } from 'jotai/utils';
import PFLink from './PFLink';
import { classNames } from '@/util/classNames';

export const pushWidgetClosedAtom = atomWithStorage<boolean>(
  'pushWidgetClosed',
  false,
  undefined,
  {
    getOnInit: true,
  },
);

export function PushNotificationsWidget(props) {
  const { gapBottom } = props;
  const { isPushAviable, askPermission, subscribeButtonOnClick, isSubscribed } =
    usePush(undefined, true);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(false);
  }, []);

  if (isLoading || !isPushAviable) {
    return null;
  }

  return (
    <Suspense>
      <article
        className={classNames(
          'w-full sm:w-[300px] bg-secundaryColor flex flex-col gap-m p-base text-center rounded-xl justify-center',
          gapBottom && 'pb-12',
        )}
      >
        {!isSubscribed && (
          <>
            <div>
              {props.children}
              <PFText tag="h2" className="text-white font-semibold" size="base">
                Verpasse keine Promiflash-Topnews!
              </PFText>
            </div>
            <PFText className="text-white" size="small">
              Melde dich jetzt für Push-Benachrichtigungen an und bleib immer
              auf dem Laufenden.
            </PFText>
            <PFButton
              onClick={(event) => {
                askPermission()
                  .then(() => {
                    subscribeButtonOnClick(event);
                  })
                  .catch((err) => {
                    console.error(err);
                  });
              }}
              variant={'invertedHover'}
            >
              <PFText size="small" className="font-normal">
                Push aktivieren
              </PFText>
            </PFButton>
            {/* <button onClick={() => setPushWidgetClosed(true)}>
              <PFText size="small" className="font-normal text-white p-3 mt-1">
                Nein Danke
              </PFText>
            </button> */}
          </>
        )}
        {isSubscribed && (
          <>
            <div>
              {props.children}
              <PFText tag="h2" className="text-white font-semibold" size="base">
                Verwalte deine Push Einstellungen
              </PFText>
            </div>
            <PFText className="text-white" size="small">
              Bleibe auf dem Laufenden über die aktuellsten Nachrichten aus der
              Welt der Stars.
            </PFText>
            <PFLink href={'/push'}>
              <PFButton asChild variant="invertedHover">
                <PFText size="small" className="font-normal">
                  Push Einstellungen
                </PFText>
              </PFButton>
            </PFLink>
          </>
        )}
      </article>
    </Suspense>
  );
}
